import React, { useState } from 'react';

const IncomeProof = ({ onNext, answers, stepKey }) => {
  const [selectedAnswer, setSelectedAnswer] = useState(answers && answers[stepKey] ? answers[stepKey] : null);

  const handleClick = (value) => {
    setSelectedAnswer(value);
    onNext(value);
  };

  return (
    <>
      <div className="qs-card__head">
        <h2 className="qs-card__title">
          Approved Without Income Proof?
        </h2>
      </div>
      <div className="qs-card__body">
        <p className="qs-card__sub">
          If you were unemployed or receiving benefits, did the lender approve the loan without requesting financial evidence (e.g. bank statements, benefit letters, proof of income)?
        </p>
        <div className="qs-actions">
          <button 
            type="button" 
            className={`qs-btn qs-btn--yes ${selectedAnswer == 464 ? 'btn-active' : ''}`}
            onClick={() => handleClick(464)}
            value="464"
          >
            Yes
          </button>
          <button 
            type="button" 
            value="465" 
            className={`qs-btn qs-btn--no ${selectedAnswer == 465 ? 'btn-active' : ''}`}
            onClick={() => handleClick(465)}
          >
            No
          </button>
        </div>
      </div>
    </>
  );
};

export default IncomeProof;
